import React from 'react'
import { Container, Grid } from '@mui/material'
import { P } from '../../Styles/style'
import styled from '@emotion/styled'
import colorbg from '../../../assets/colorbg.png'
import Twitter from '../../../assets/twitter.png'
import Telegram from '../../../assets/telegram.png'
import Medium from '../../../assets/medium.png'
import bigdog from '../../../assets/bigdog.png'

const WhyWrapper = styled.div`
  padding: 12rem 0;
  background-image: url(${colorbg});
  min-height: 100vh;
  background-size: cover;
  display: flex;
  align-items: center;
`;
const SectionHeading = styled.div`
font-size: 50px;
font-family: "Poppins-Bold";
`;
const SectionSubHeading = styled.div`
font-size: 30px;
max-width: 60%;
color: #BA51FF;
  font-family: "Poppins-SemiBold";
  @media screen and (max-width:599px){
    font-size: 25px;
    max-width: 100%;      
  }
`;
const SocialMediaDiv = styled.div`
display:flex;
`;
const FollowHeading = styled.div`
padding: 30px 0 10px 0;
font-weight:900;
font-size:20px;
`;
const SocialImg = styled.img`
width: 100%;
height: auto;
max-width: 50px;
`;
const DogImg = styled.img`
width: 100%;
height: auto;
max-width: 400px;
`;
const why = () => {
  return (
    <div>
       <WhyWrapper id="about">
        <Container maxWidth="xl">
          <Grid container>
          <Grid item xs={12} md={6}>
            <SectionHeading>
            Why SANSHU
            </SectionHeading>
            <SectionSubHeading>
            "Who Controls The Memes, 
            Control The Universe"<br/>
            - Elon Musk
            </SectionSubHeading>
            <P>
            Sanshu Inu is Shiba Inus baby sister who always followed in her big brothers footsteps her entire life. However, in doing so, Sanshu always felt like she was in Shibas shadows and never got the recognition she deserved. 
            <br/>
            <br/>
            Make no mistake, Shiba Inu loves and adores her baby sis Sanshu but he is overprotective of her and doesn’t talk about her much in public because he doesn’t believe Sanshu Inu can handle the spotlight of fame. Sanshu Inu appreciates her big brothers protection but she doesn’t want to hide inside her lil dog house anymore. Sanshu wants to show the world that she has what it takes to become as great as her big brother Shiba Inu, after all they are cut from the same cloth! Because of the love she has for her big brother Shiba Inu, she has decided to create a token that rewards their Sanshu Inu holders with Shiba rewards.
            </P>
            <FollowHeading>Follow us:</FollowHeading>
            <SocialMediaDiv>
              <a href="https://twitter.com/sanshuinutoken" target="_blank">
                <SocialImg src={Twitter} />
              </a>
              <a href="https://t.me/sanshuinuportal" target="_blank">
                <SocialImg src={Telegram} />
              </a>
              <a href="#" target="_blank">
                <SocialImg src={Medium} />
              </a>
            </SocialMediaDiv>
          </Grid>
          <Grid item xs={12} md={6} style={{textAlign: 'end', padding: '3.5rem 0'}}>
            <DogImg src={bigdog} />
          </Grid>
          </Grid>
        </Container>
        </WhyWrapper>
    </div>
  )
}

export default why